import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLanguage } from "../i18n/LanguageContext";
import { trackEvent } from "../lib/analytics";

export const Footer = () => {
  const { t } = useLanguage();
  const navLinks = [
    [t("nav.features"), "#ominaisuudet"],
    [t("nav.workflow"), "#tyonkulku"],
    [t("nav.pricing"), "#hinnasto"],
    [t("nav.faq"), "#ukk"],
    [t("nav.contact"), "#yhteystiedot"],
  ];
  return (
    <footer data-testid="site-footer" className="relative border-t-2 border-[#1f1f1f] bg-[#0a0a0a]">
      <div className="h-2 hazard-stripes-anim" />

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <Logo size={56} aura testId="footer-logo" />
            <div className="leading-none">
              <div className="font-display font-bold text-white text-2xl tracking-wider">DUUNARI</div>
              <div className="font-mono text-[10px] tracking-[0.25em] text-[#FFEA00] mt-1">{t("footer.made_in")}</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#A3A3A3] max-w-sm leading-relaxed">{t("footer.tagline")}</p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase mb-4">{t("footer.nav_heading")}</div>
          <ul className="space-y-2.5">
            {navLinks.map(([label, href]) => (
              <li key={href}>
                <a href={href} data-testid={`footer-link-${href.replace("#", "")}`} className="font-display uppercase text-sm tracking-wider text-white hover:text-[#FFEA00] transition-colors">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase mb-4">{t("footer.contact_heading")}</div>
          <a href="mailto:duunari.online@gmail.com" data-testid="footer-email" onClick={() => trackEvent("Click: Email")} className="font-display text-white hover:text-[#FFEA00] text-lg tracking-wide block break-all">duunari.online@gmail.com</a>
          <div className="mt-2 font-mono text-xs text-[#A3A3A3]">{t("footer.location_line")}</div>

          <div className="mt-8">
            <div className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase mb-3">{t("footer.important_heading")}</div>
            <div className="flex flex-col gap-2">
              <Link to="/kayttoehdot" data-testid="footer-link-kayttoehdot" className="font-display uppercase text-sm tracking-wider text-[#FFEA00] hover:text-white transition-colors inline-flex items-center gap-2 group w-fit">
                <span className="w-1.5 h-1.5 bg-[#FFEA00] group-hover:bg-white transition-colors" />
                {t("footer.kayttoehdot")}
              </Link>
              <Link to="/tietosuojaseloste" data-testid="footer-link-tietosuojaseloste" className="font-display uppercase text-sm tracking-wider text-[#FFEA00] hover:text-white transition-colors inline-flex items-center gap-2 group w-fit">
                <span className="w-1.5 h-1.5 bg-[#FFEA00] group-hover:bg-white transition-colors" />
                {t("footer.tietosuojaseloste")}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t-2 border-[#1f1f1f]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-mono text-[10px] tracking-[0.25em] text-[#A3A3A3] uppercase">© {new Date().getFullYear()} Duunari · {t("footer.copyright")}</div>
          <div className="flex items-center gap-5">
            <Link to="/kayttoehdot" className="font-mono text-[10px] tracking-[0.25em] text-[#A3A3A3] uppercase hover:text-[#FFEA00] transition-colors">{t("footer.kayttoehdot")}</Link>
            <Link to="/tietosuojaseloste" className="font-mono text-[10px] tracking-[0.25em] text-[#A3A3A3] uppercase hover:text-[#FFEA00] transition-colors">{t("footer.tietosuoja_short")}</Link>
            <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-[#A3A3A3] uppercase">
              <span className="w-1.5 h-1.5 bg-[#FFEA00] pulse-dot" />
              {t("footer.status_online")}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
